import script from "./BlogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetail.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetail.vue?vue&type=style&index=0&id=0fa520cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa520cc"]])

export default __exports__